import React, { useState } from "react"
import FormBuilder from "../../../class/tool/FormBuilder"
import FormPwd from "./FormPwd";

const AccountMeFormSheet = props => {
    const { object, values, errors, updated, setGlobalError, handleChange, handleSave } = props
    const [ edit, setEdit ] = useState("")
    const [ rows, setRows ] = useState([
        {
            label: "Nom",
            attribute: "lastname",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Prénom",
            attribute: "firstname",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Email",
            attribute: "email",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        }
    ])
    const [ pwdForm, setPwdForm ] = useState(false)

    const buildRow = row => {
        if (edit === row.attribute || ["color"].includes(row.inputType))
            return FormBuilder.buildInputByType(row, values, errors, change, reinitEdit);
        else
            return FormBuilder.buildNoInputByType(row, values, handleEdit);
    }
    const handleEdit = attribute => {
        setEdit(attribute);
    }
    const change = (attribute, returnType, val, strict = false) => {
        handleChange(rows, attribute, returnType, val, strict);
    }
    const reinitEdit = () => {
        setEdit("");
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault();
        handleSave();
    }
    const showPasswordForm = () => {
        setPwdForm(!pwdForm)
    }

    return (
        <div className="clearing">
            <form
                className={"form inOverbox"}
                onSubmit={ handleSubmit } >
                {
                    rows.map((row, index) => (
                        <div key={ index } className="clearing">
                            <label className={ row.classnameLabel }>{ row.label }</label>
                            {
                                buildRow(row)
                            }
                        </div>
                    ))
                }
                <div className="inForm">
                    <p className="button left unlock" onClick={ showPasswordForm }><span>Modifier mon mot de passe</span></p>
                </div>
            </form>
            {
                pwdForm
                && <FormPwd object={ object } closeView={ showPasswordForm } />
            }
        </div>
    )
}

export default AccountMeFormSheet
